'use client'

import { Checkbox, ScrollArea, Stack, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { Controller } from 'react-hook-form'
import { MultistepForm } from '../../../components/Multistep'

import classes from './terms-step.module.css'

interface Props {
    form: MultistepForm<any>
}

export default function TermsStep({ form }: Props) {
    const t = useTranslations('auth.terms')
    const {
        control,
        formState: { errors }
    } = form

    return (
        <Stack gap='xl'>
            <ScrollArea
                h={{ base: 160, sm: 200 }}
                type='auto'
                p='lg'
                classNames={{ root: classes.legalScroll }}
                offsetScrollbars>
                <Text size='md' lh={1.65}>
                    <b>{t('termsOfService')}</b>
                    <br />
                    {t('placeholder')}
                </Text>
            </ScrollArea>
            <Controller
                control={control}
                name='acceptedTerms'
                render={({ field }) => (
                    <Checkbox
                        size='lg'
                        checked={field.value}
                        onChange={(e) => field.onChange(e.currentTarget.checked)}
                        label={t('acceptTerms')}
                        error={errors.acceptedTerms?.message as string}
                    />
                )}
            />
            <ScrollArea
                h={{ base: 160, sm: 200 }}
                type='auto'
                p='lg'
                classNames={{ root: classes.legalScroll }}
                offsetScrollbars>
                <Text size='md' lh={1.65}>
                    <b>{t('privacyPolicy')}</b>
                    <br />
                    {t('placeholder')}
                </Text>
            </ScrollArea>
            <Controller
                control={control}
                name='acceptedPrivacy'
                render={({ field }) => (
                    <Checkbox
                        size='lg'
                        checked={field.value}
                        onChange={(e) => field.onChange(e.currentTarget.checked)}
                        label={t('acceptPrivacy')}
                        error={errors.acceptedPrivacy?.message as string}
                    />
                )}
            />
        </Stack>
    )
}
